var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service"},[_c('HeaderReturn',{attrs:{"title":"联系客服"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service_ul"},[_c('div',[_c('img',{attrs:{"src":require("../../assets/img/page/kf.png")}}),_c('p',[_vm._v("TY 客服")])])])
}]

export { render, staticRenderFns }